<h2 class="content-block">
    {{welcomeMessage}}
</h2>
<div class="content-block">
    <img [src]="rcsLogo"/>
</div>

